import merge from 'lodash/merge'
import unionBy from 'lodash/unionBy'
import { formatPassHolder } from 'helpers'
import { formatCards, formatCard } from 'helpers'
import { formatDebitor } from 'helpers'
import { formatPayment } from 'helpers'
import { formatTickets } from 'helpers'

const defaultState = {
  items: {}
}

const annualPassHolders = (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_MEMBER_PASS_HOLDERS': {
      let items

      action.payload.forEach(annualPassHolder => {
        const item = formatPassHolder(annualPassHolder)

        items = {
          ...items,
          [item.id]: item
        }
      })

      return {
        ...state,
        items: merge(state.items, items)
      }
    }
    case 'SET_MEMBER_PASS_HOLDER': {
      const { annualPassHolderId, annualPassHolder } = action.payload

      const newAnnualPassHolder = {
        ...formatPassHolder(annualPassHolder),
        loaded: true
      }

      return {
        ...state,
        items: {
          ...state.items,
          [annualPassHolderId]: merge(
            state.items[annualPassHolderId],
            newAnnualPassHolder
          )
        }
      }
    }
    case 'SET_MEMBER_PASS_PAYMENTS': {
      const { annualPassHolderId } = action.payload
      let payments = []

      payments = action.payload.payments
        .map(payment => formatPayment(payment))
        .sort((a, b) => b.getTime - a.getTime)

      return {
        ...state,
        items: {
          ...state.items,
          [annualPassHolderId]: {
            ...state.items[annualPassHolderId],
            payments
          }
        }
      }
    }
    case 'SET_MEMBER_PASS_TICKETS': {
      const annualPassHolderId = action.payload.annualPassHolderId
      const tickets = action.payload.tickets

      return {
        ...state,
        items: {
          ...state.items,
          [annualPassHolderId]: {
            ...state.items[annualPassHolderId],
            ...formatTickets(tickets, 'membership')
          }
        }
      }
    }
    case 'CREATE_MEMBER_PASS_HOLDER': {
      const annualPassHolder = formatPassHolder(action.payload)
      const id = annualPassHolder.member_id
      const formerAnnualPassHolder = state.items[id]
        ? state.items[id]
        : {
            ticketStats: {
              comingShows: 0,
              completedShows: 0,
              noshowShows: 0
            },
            cards: []
          }

      const item = {
        ...formerAnnualPassHolder,
        ...annualPassHolder,
        cards: unionBy(
          annualPassHolder.cards,
          formerAnnualPassHolder.cards,
          'card_id'
        )
      }

      return {
        ...state,
        items: {
          ...state.items,
          [id]: item
        }
      }
    }
    case 'SET_MEMBER_PASS_TIME': {
      const annualPassHolder = action.payload
      const id = annualPassHolder.member_id

      const newCards = formatCards(annualPassHolder.cards)
      const cards = state.items[id].cards.map(card => {
        const newCard = newCards.filter(c => c.card_id === card.card_id)[0]
        if (newCard) {
          return newCard
        }
        return card
      })

      return {
        ...state,
        items: {
          ...state.items,
          [id]: {
            ...state.items[id],
            cards
          }
        }
      }
    }
    case 'SET_UPDATE_MEMBER_PASS_HOLDER': {
      const { annualPassHolderId, annualPassHolder } = action.payload
      const newAnnualPassHolder = formatDebitor(annualPassHolder)
      const updatedAnnualPassHolder = merge(
        state.items[annualPassHolderId],
        newAnnualPassHolder
      )

      return {
        ...state,
        items: {
          ...state.items,
          [annualPassHolderId]: updatedAnnualPassHolder
        }
      }
    }
    case 'SET_NEW_MEMBER_BARCODE': {
      const { annualPassHolderId, cardId, barcode } = action.payload

      return {
        ...state,
        items: {
          ...state.items,
          [annualPassHolderId]: {
            ...state.items[annualPassHolderId],
            cards: state.items[annualPassHolderId].cards.map(card => {
              if (card.card_id === cardId) {
                return {
                  ...card,
                  barcode
                }
              }
              return card
            })
          }
        }
      }
    }
    case 'TOGGLE_MEMBER_STANDBY': {
      const { annualPassHolderId, cardId } = action.payload
      return {
        ...state,
        items: {
          ...state.items,
          [annualPassHolderId]: {
            ...state.items[annualPassHolderId],
            cards: state.items[annualPassHolderId].cards.map(card => {
              if (card.card_id === cardId) {
                return {
                  ...card,
                  standby: card.standby === 0 ? 1 : 0
                }
              }
              return card
            })
          }
        }
      }
    }
    case 'SET_NEW_MEMBER_PERIOD': {
      const { annualPassHolderId, cardId, new_card } = action.payload

      return {
        ...state,
        items: {
          ...state.items,
          [annualPassHolderId]: {
            ...state.items[annualPassHolderId],
            cards: state.items[annualPassHolderId].cards.map(card => {
              if (card.card_id === cardId) {
                return {
                  ...card,
                  ...formatCard(new_card)
                }
              }
              return card
            })
          }
        }
      }
    }
    case 'SET_CANCEL_MEMBER_PASS': {
      const { annualPassHolderId, cardId } = action.payload

      const cards = state.items[annualPassHolderId].cards.map(card => {
        if (card.card_id + '' === cardId + '') {
          return {
            ...card,
            active: false
          }
        }
        return card
      })

      return {
        ...state,
        items: {
          ...state.items,
          [annualPassHolderId]: {
            ...state.items[annualPassHolderId],
            cards
          }
        }
      }
    }
    default: {
      return state
    }
  }
}

export default annualPassHolders
